import React, { memo, useCallback } from "react";
import styled from "styled-components";
import { useSearchParams } from "react-router-dom";
import VerticalLine from "../../../../../common/assets/icons/vertical_line";
import {
  MinusTranslationIcon,
  PlusTranslationIcon,
} from "../../../../../common/assets/icons";
import { formatBibleBookShortName } from "../../../../../common/utils/functions/bible_page_functions";
import { BIBLE_BOOK_NAMES_DATA } from "../../../bible_page_data";

const LeftButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
  background: #fff;
  border-radius: 15px;
  overflow: hidden;
`;

const BiblePlaceButton = styled.button`
  display: flex;
  align-items: center;
  height: 100%;
  min-width: 66px;
  padding: 0 10px 0 13px;
  color: #1e1e1e;
  font-size: 14px;
  font-weight: 400;
  line-height: 122%;
  letter-spacing: 0.14px;
`;

const BibleTranslationButton = styled.button`
  display: flex;
  align-items: center;
  width: max-content;
  height: 100%;

  p {
    text-transform: uppercase;
    padding: 0 10px;
    color: #f8d254;
    font-size: 14px;
    font-weight: 600;
    line-height: 122%;
    letter-spacing: 0.4px;
    flex: 1;
  }
`;

const PlusTranslationButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 13px 0 10px;
  height: 100%;
`;

const VerticalLineStyled = styled(VerticalLine)`
  width: 1px;
`;

const BibleMainLeftButtons = ({
  isFirstTranslation,
  hasSecondTranslaition,
  chapterData,
  currentTranslation,
  setActiveScreenMobile,
  setOpenBibleNavigation,
  setOpenBibleTranslation,
  bibleId,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const shouldHideButton = isFirstTranslation && hasSecondTranslaition;
  const currentChapterNum = chapterData?.[0]?.chapter_num;

  const bookNameData =
    BIBLE_BOOK_NAMES_DATA[currentTranslation?.bible_locale]?.[
      chapterData?.[0]?.book_code
    ]?.short_name;
  const formatedBookName = formatBibleBookShortName(bookNameData);

  const handleOpenBibleNavigation = useCallback((event) => {
    event.stopPropagation();
    setActiveScreenMobile("bible_navigation");
    setOpenBibleNavigation(true);
  }, []);

  const handleOpenBibleTranslation = useCallback((event) => {
    event.stopPropagation();
    setActiveScreenMobile("bible_translation");
    setOpenBibleTranslation(true);
  }, []);

  const handleAddSecondTranslate = useCallback(
    (event) => {
      event.stopPropagation();

      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);

        if (!hasSecondTranslaition) {
          newParams.set("2bibleId", searchParams.get("bibleId"));
        } else {
          newParams.delete("2bibleId");
        }

        return newParams;
      });
    },
    [hasSecondTranslaition, searchParams, setSearchParams]
  );

  return (
    <LeftButtonsContainer>
      <BiblePlaceButton onClick={handleOpenBibleNavigation}>
        {formatedBookName} {currentChapterNum}
      </BiblePlaceButton>
      <VerticalLineStyled height="24" />

      <BibleTranslationButton
        key={bibleId}
        onClick={handleOpenBibleTranslation}
      >
        <p>{bibleId}</p>
      </BibleTranslationButton>

      {!shouldHideButton && (
        <>
          <VerticalLineStyled height="24" />

          <PlusTranslationButton onClick={handleAddSecondTranslate}>
            {!hasSecondTranslaition ? (
              <PlusTranslationIcon />
            ) : (
              <MinusTranslationIcon />
            )}
          </PlusTranslationButton>
        </>
      )}
    </LeftButtonsContainer>
  );
};

export default memo(BibleMainLeftButtons);
